export const getProfilePhotoName = (userProfileId: any) => `uploads/profile_photo/${userProfileId}`;
